<template>
    <edit></edit>
</template>

<script>
    import edit from './gift_package_edit.vue'

    export default {
        name: 'gift_package_add',

        components: {
            edit
        }
    }
</script>